export default "__VITE_ASSET__CWHaJB0J__"